// extracted by mini-css-extract-plugin
export default {"registerPage":"style_registerPage__6y3WN","registerCol":"style_registerCol__nZpdG"};